// Configurações do Módulo de Parcerias
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Alert, AlertDescription } from '../ui/alert';
import { Settings, AlertTriangle, Save } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../services/api';

const ConfiguracoesParcerias = ({ user, config, onConfigUpdate }) => {
  const [configGlobal, setConfigGlobal] = useState({
    dias_validade_global: 8,
    modo_contingencia_ativo: false
  });
  
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadConfigs();
  }, []);

  const loadConfigs = async () => {
    try {
      const globalRes = await api.get('/parcerias/config');
      setConfigGlobal({
        dias_validade_global: globalRes.data.dias_validade_global || 8,
        modo_contingencia_ativo: globalRes.data.modo_contingencia_ativo || false
      });
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveGlobal = async () => {
    setSaving(true);
    try {
      await api.put('/parcerias/config', configGlobal);
      toast.success('Configuração global guardada');
      onConfigUpdate?.();
    } catch (error) {
      toast.error('Erro ao guardar configuração');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="configuracoes-parcerias">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Configuração Global
          </CardTitle>
          <CardDescription>
            Definições que afetam todas as parcerias
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label>Dias de Validade Padrão Global</Label>
              <Input
                type="number"
                min="1"
                value={configGlobal.dias_validade_global}
                onChange={(e) => setConfigGlobal(prev => ({ 
                  ...prev, 
                  dias_validade_global: parseInt(e.target.value) || 8 
                }))}
              />
              <p className="text-xs text-muted-foreground mt-1">
                Aplicado a novas parcerias que não definam valor específico
              </p>
            </div>

            <div className="flex items-center justify-between p-4 bg-orange-50 border border-orange-200 rounded-lg">
              <div>
                <Label className="text-orange-800">Modo de Contingência</Label>
                <p className="text-xs text-orange-600 mt-1">
                  Permite registo manual de vales sem cartão RFID
                </p>
              </div>
              <Switch
                checked={configGlobal.modo_contingencia_ativo}
                onCheckedChange={(v) => setConfigGlobal(prev => ({ 
                  ...prev, 
                  modo_contingencia_ativo: v 
                }))}
              />
            </div>
          </div>

          {configGlobal.modo_contingencia_ativo && (
            <Alert variant="warning" className="bg-orange-50 border-orange-200">
              <AlertTriangle className="h-4 w-4 text-orange-600" />
              <AlertDescription className="text-orange-700">
                O modo de contingência está ativo. Os colaboradores podem registar vales manualmente.
                Desative após resolver a situação pontual.
              </AlertDescription>
            </Alert>
          )}

          <Button onClick={handleSaveGlobal} disabled={saving} data-testid="btn-guardar-config-global">
            <Save className="h-4 w-4 mr-2" />
            Guardar Configuração Global
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ConfiguracoesParcerias;
